import { render, staticRenderFns } from "./training-completed.vue?vue&type=template&id=8f50bc4a&scoped=true"
import script from "./training-completed.vue?vue&type=script&lang=js"
export * from "./training-completed.vue?vue&type=script&lang=js"
import style0 from "./training-completed.vue?vue&type=style&index=0&id=8f50bc4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f50bc4a",
  null
  
)

export default component.exports